import React from 'react';

function ListingDetailWallet(props: object) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.5514 2.09853L10.5264 2.15686L8.10977 7.76519H5.73477C5.1681 7.76519 4.62643 7.88186 4.13477 8.09019L5.5931 4.60686L5.62643 4.52353L5.68477 4.39019C5.70143 4.34019 5.7181 4.29019 5.7431 4.24853C6.83477 1.72353 8.0681 1.14853 10.5514 2.09853Z"
        stroke="#DC00FE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0427 7.93172C14.6677 7.81506 14.2677 7.76505 13.8677 7.76505H8.10938L10.526 2.15672L10.551 2.09839C10.676 2.14006 10.7927 2.19839 10.9177 2.24839L12.7594 3.02339C13.7844 3.44839 14.501 3.89006 14.9344 4.42339C15.0177 4.52339 15.0844 4.61506 15.1427 4.72339C15.2177 4.84006 15.276 4.95672 15.3094 5.08172C15.3427 5.15672 15.3677 5.23172 15.3844 5.29839C15.6094 5.99839 15.476 6.85672 15.0427 7.93172Z"
        stroke="#DC00FE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9341 11.832V13.457C17.9341 13.6237 17.9258 13.7904 17.9174 13.957C17.7591 16.8654 16.1341 18.332 13.0508 18.332H6.55078C6.35078 18.332 6.15078 18.3154 5.95911 18.2904C3.30911 18.1154 1.89245 16.6987 1.71745 14.0487C1.69245 13.857 1.67578 13.657 1.67578 13.457V11.832C1.67578 10.157 2.69245 8.71538 4.14245 8.09038C4.64245 7.88205 5.17578 7.76538 5.74245 7.76538H13.8758C14.2841 7.76538 14.6841 7.82371 15.0508 7.93205C16.7091 8.44038 17.9341 9.99038 17.9341 11.832Z"
        stroke="#DC00FE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.59102 4.60669L4.13268 8.09002C2.68268 8.71502 1.66602 10.1567 1.66602 11.8317V9.39002C1.66602 7.02336 3.34935 5.04836 5.59102 4.60669Z"
        stroke="#DC00FE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9322 9.38963V11.8313C17.9322 9.99797 16.7155 8.43963 15.0488 7.93963C15.4822 6.8563 15.6072 6.0063 15.3988 5.29797C15.3822 5.22297 15.3572 5.14797 15.3238 5.0813C16.8738 5.8813 17.9322 7.52297 17.9322 9.38963Z"
        stroke="#DC00FE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ListingDetailWallet;
